import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取月收益汇总
   * @param poiId 门店ID
   * @param poiStatus 门店的商家入驻状态 1-已签约、2-已开通、3-已解约
   * @param poiSource 门店来源 1-运营平台、2-上单系统
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   * @returns {*}
   */
  getProfitOverview(poiId, poiStatus, poiSource, year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-in-month', {
      poiId,
      poiStatus,
      poiSource,
      queryMonth, // int 类型 yyyyMM格式 202002
    });
  },
  /**
   * 获取月订单数据（分页）
   * @param poiId 门店ID
   * @param poiStatus 门店的商家入驻状态 1-已签约、2-已开通、3-已解约
   * @param poiSource 门店来源 1-运营平台、2-上单系统
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   * @param pageNo 当前页，默认是 1
   * @param pageSize 每页数量，默认20
   * @returns {*}
   */
  getProfitDetail(poiId, poiStatus, poiSource, year, month, pageNo = 1, pageSize = 20) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/list-in-page', {
      poiId,
      poiStatus,
      poiSource,
      queryMonth, // int 类型 yyyyMM格式 202002
      pageNo,
      pageSize,
    });
  },
  /**
   * 2021年8月及以前导出账单
   * @param billStatus 账单状态
   * @param billMonth 账单月份 yyyyMM
   * @param email 邮件地址
   */
  sendBillMailBeforeTimeNode({ billStatus, billMonth, email }) {
    return axios.post('/api/v1/bill/mail', {
      billStatus,
      billMonth,
      email,
    });
  },
  /**
   * 查询导出账单最小月份
   * @param accountType
   * @returns
   */
  getMinMonth(accountType) {
    return axios.post('/api/bill/v2/min-month', { accountType });
  },
  /**
   * 2021年9月及以后导出账单
   */
  sendBillMailAfterTimeNode(params) {
    // 账单状态：1-已出账单，2-未出账单
    params.billStatus = 2;
    return axios.post('/api/bill/v2/export', params);
  },
  /**
   * 全部门店上月、昨日收益汇总
   * @param poiId 门店ID
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   */
  getSummaryByAcc(poiId, year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-by-acc', {
      poiId,
      queryMonth,
    });
  },
  /**
   * 全部门店收益汇总、每个门店收益汇总
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   */
  getSummaryByAccDetail(year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-by-acc-detail', {
      queryMonth,
    });
  },
  /**
   * xy项目补活动费
   */
  getXyRepair() {
    return axios.get('/api/v1/bill/get-xy-repair');
  },
  /**
   * 门店月账单
   * @param poiId 门店ID
   */
  getSummaryMonthList(poiId) {
    return axios.post('/api/v1/bill/summary-month', {
      poiId,
    });
  },
  /**
   * 门店日账单
   * @param poiId 门店ID
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   */
  getSummaryDayList(poiId, year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-day', {
      poiId,
      queryMonth,
    });
  },
  /**
   * 月成本摊销
   * @param poiId 门店ID
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   */
  getSummaryMonthCost(poiId, year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-month-cost', {
      poiId,
      queryMonth,
    });
  },
  /**
   * 月其他款项
   * @param poiId 门店ID
   * @param year 查询年份 yyyy
   * @param month 查询月份 MM
   */
  getSummaryMonthOtherRevise(poiId, year, month) {
    const queryMonth = year * 100 + month;
    return axios.post('/api/v1/bill/summary-month-other-revise', {
      poiId,
      queryMonth,
    });
  },
  /**
   * 门店日流水
   * @param poiId 门店ID
   * @param queryDay 开始时间 格式yyyyMMdd
   * @param pageNo 页数
   * @param pageSize 页大小
   */
  getFlowInPage(poiId, queryDay, pageNo, pageSize = 20) {
    return axios.post('/api/v1/bill/flow-in-page', {
      poiId,
      queryDay,
      pageNo,
      pageSize,
    });
  },
};
